import React, { memo } from "react";
import { useLocation, Link } from "react-router-dom";
import {
  Stack,
  Typography,
  Icon,
  Card,
  CardContent,
  Box,
} from "investira.react.components";
import { BaseTemplate, PaginationTemplate } from "../../components/templates";

const Correlacoes = memo((props) => {
  const location = useLocation();

  const CORRELACOES = {
    pares: {
      id: "pares",
      descricao: "Correlação Pares",
      iconName: "chart_lines",
      available: true,
      descricao_longa:
        "Visualize a correlação histórica entre dois ou mais ativos ou índices de sua escolha. Descubra como se movimentam em conjunto ao longo do tempo e identifique relações positivas ou negativas entre pares de investimentos.",
    },
    analise: {
      id: "analise",
      descricao: "Análise Carteira",
      iconName: "chart_lines",
      // apenas disponível para usuarios logados
      available: true,
      descricao_longa:
        "Analise a correlação entre os ativos da sua carteira e os benchmarks para entender o grau de diversificação. Identifique concentrações de risco e oportunidades para otimizar a composição do portfólio, reduzindo a volatilidade geral.",
    },
  };

  return (
    <BaseTemplate
      title={"Correlações"}
      subtitle={props.subtitle}
      description=""
      maxWidth={"xl"}
    >
      <Box
        role="list"
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(1, 1fr)",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          },
          gap: "16px 16px",
        }}
      >
        {Object.values(CORRELACOES).map((option) => (
          <Link
            to={option.available ? `${location.pathname}/${option.id}` : "#"}
            aria-label={`Ver lista de ${option.descricao}`}
            style={{ pointerEvents: option.available ? "auto" : "none" }}
          >
            <Card
              sx={{
                height: "100%",
                display: "flex",
                opacity: option.available ? 1 : 0.3,
              }}
            >
              <CardContent
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  flexGrow: 1,
                  p: 3,
                }}
              >
                <Stack gap="16px">
                  <Icon iconName={option.iconName} color="primary" size={32} />
                  <Stack>
                    <Typography variant="h6" component="h2" color="textPrimary">
                      {option.descricao}
                    </Typography>
                    <Typography
                      variant="caption"
                      component="h2"
                      color="textPrimary"
                      gutterBottom
                    >
                      {option.descricao_longa}
                    </Typography>
                  </Stack>
                </Stack>
              </CardContent>
            </Card>
          </Link>
        ))}
      </Box>
    </BaseTemplate>
  );
});

PaginationTemplate.displayName = "PaginationTemplate";

export default Correlacoes;
